// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'H',
    mixins: [
        template,
    ]
})
export class H extends Vue {

    public get headingLineClass() {
        return this.line ? `${this.$appPrefix}-h--line-${this.size}` : ''
    }

    public get headingClass() {
        return `wb-e-hdl-${this.themeMap[this.size]}`
    }

    // size => workbech class
    public themeMap = {
        1: 1,
        2: 3,
        3: 6,
        4: 21,
    }

    @Prop({default: 'default'})
    public theme!: string

    @Prop({type: [Number, String], default: '2'})
    public size!: string | number

    @Prop({default: false})
    public line!: boolean

    public created() {

    }

    public mounted () {

    }

    public destroyed() {

    }
}